import { PortfolioViewMenuAdditionalInfo } from "../../../../../Wrap/Models/Domains/Menu/PortfolioViewMenuAdditionalInfo";
import { SingleDataStore } from "../../../../Shared/Stores/SingleDataStore";
import { SingleDataStoreDispacher } from "../../../../Shared/Stores/SingleDataStoreDispacher";

export const PortfolioViewMenuAdditionalInfoDisaptcher: SingleDataStoreDispacher<PortfolioViewMenuAdditionalInfo> = new SingleDataStoreDispacher<
    PortfolioViewMenuAdditionalInfo
>();
export const PortfolioViewMenuAdditionalInfoStore: SingleDataStore<PortfolioViewMenuAdditionalInfo> = new SingleDataStore<
    PortfolioViewMenuAdditionalInfo
>(PortfolioViewMenuAdditionalInfoDisaptcher);
